// extracted by mini-css-extract-plugin
module.exports = {"container":"_1VUDImegOV-r9jncHJGBCX"};